import { createSelector } from 'reselect'
import { sortAwaitingPickupOrders, sortProcessingPickupOrders } from './helper'
import { roundPrice } from '../../../helper'
import { getPrepaidSum } from '../../../helper/getPrepaidPayments'

const selectSelectedOrder = store => store.pickupMonitor.selectedOrder
export const selectAwaitingPickupOrders = store => store.pickupMonitor.awaitingPickupOrders
export const selectProcessingPickupOrders = store => store.pickupMonitor.processingPickupOrders

export const selectIsPaid = createSelector(
	selectSelectedOrder,
	(selectedOrder) => {
		const orderPayment = selectedOrder?.payments?.filter(item => item?.method === selectedOrder?.paymentMethod)
		return orderPayment?.[0]?.payed
	},
)

export const selectTotalSum = createSelector(
	selectSelectedOrder,
	selectIsPaid,
	(selectedOrder, isPaid) => {
		const totalSum = (isPaid && selectedOrder?.tips) ? roundPrice(selectedOrder?.totalPrice - selectedOrder?.tips) : selectedOrder?.totalPrice
		return isPaid ? totalSum : roundPrice(totalSum - getPrepaidSum(selectedOrder))
	},
)

export const selectSortedAwaitingPickupOrders = createSelector(
	selectAwaitingPickupOrders,
	(awaitingPickupOrders) => {
		return [...awaitingPickupOrders].sort(sortAwaitingPickupOrders)
	},
)

export const selectSortedProcessingPickupOrders = createSelector(
	selectProcessingPickupOrders,
	(processingPickupOrders) => {
		return [...processingPickupOrders].sort(sortProcessingPickupOrders)
	},
)
